import React, { useState } from "react";
import { adminLogin } from "./adminApi";
import { useLanguage } from "./context/LanguageContext";

interface LoginScreenProps {
  onLogin: () => void;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ onLogin }) => {
  const { t } = useLanguage();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await adminLogin(username, password);
      if (result === "ok") {
        onLogin();
      } else if (result === "rate_limited") {
        setError(t("Too many failed login attempts. Please try again in 15 minutes."));
      } else if (result === "invalid") {
        setError(t("Invalid login or password"));
      } else {
        setError(t("Server not reachable. Please try again later."));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <img className="login-card__logo" src="/logo-wplusm-2026.svg" alt="WplusM" />
        <p className="login-card__subtitle">{t("Admin-Panel")}</p>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">{t("Login")}</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t("Enter your login")}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t("Password")}</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t("Enter your password")}
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? t("Signing in...") : t("Sign in")}
          </button>

          {error && <p className="error-message">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
